import '../../assets/js/particles/lib/leap-0.6.4';
import '../../assets/js/particles/lib/leap-plugins-0.1.10';

import '../../assets/js/particles/lib/dat.gui';
import '../../assets/js/particles/lib/mousetrap';
import '../../assets/js/particles/lib/three70';
import '../../assets/js/particles/lib/Stats';
import '../../assets/js/particles/lib/Clock';
import '../../assets/js/particles/lib/TrackballControls';
import '../../assets/js/particles/lib/OrbitControls';
import '../../assets/js/particles/lib/CopyShader';
import '../../assets/js/particles/lib/OBJLoader';

import '../../assets/js/particles/src/RenderContext';
import '../../assets/js/particles/src/ParticleEngine';
import '../../assets/js/particles/src/UpdateLoop';
import '../../assets/js/particles/src/Utils';
import '../../assets/js/particles/src/Mouse';
import '../../assets/js/particles/src/ShaderPass';
import '../../assets/js/particles/src/SimulationRenderer';
import '../../assets/js/particles/src/ParticleSimulation';
import '../../assets/js/particles/src/UVMapper';
import '../../assets/js/particles/src/UVMapAnimator';
import '../../assets/js/particles/src/LeapManager';
import '../../assets/js/particles/src/App2';

import '../../assets/js/particles/src/shaders/SimShader';
import '../../assets/js/particles/src/shaders/SimInitShader';
import '../../assets/js/particles/src/shaders/ParticleShader';
import '../../assets/js/particles/src/shaders/SimDebugShader';
import '../../assets/js/particles/src/shaders/UVMapShader';

import { bindEvents } from '../../assets/js/helpers';

export const selector = 'hero-animation';

export default class HeroAnimation {

	constructor(section) {
		this.el = {
			section,
			fallbackImage: document.querySelector(`.${selector}__fallback`)
		};

		this.events = bindEvents(this);
		this.addEventListeners();

		if ('ontouchstart' in document) {
			this.el.fallbackImage.classList.add('is-active');
			this.el.section.classList.add('is-hidden');
		} else {
			this.app = new App();
			window.dispatchEvent(new Event('resize'));
		}
	}

	_onWindowResize() {

	}

	_onWindowLoad() {

	}

	_onDomContentLoaded() {
		window.dispatchEvent(new Event('resize'));
	}

	addEventListeners() {
		window.addEventListener('load', this.events._onWindowLoad);
		window.addEventListener('resize', this.events._onWindowLoad);
	}

	removeEventListeners() {
		window.removeEventListener('load', this.events._onWindowLoad);
		window.removeEventListener('resize', this.events._onWindowLoad);
	}

	destroy() {
		this.removeEventListeners();
		this.el = null;
	}

}
